export const AccidentInsuranceRoutes = {
    ROOT: "/accident-insurance",
    PERSONAL_DATA: "/accident-insurance/personal-data",
    NEW_PHONE: "/accident-insurance/new-phone",
    NEW_ADDRESS: "/accident-insurance/new-address",
    SUCCESS: "/accident-insurance/success"
};



// WEBPACK FOOTER //
// ./src/components/accidentInsurance/AccidentInsuranceRoutes.ts